
















import { Component, Mixins, Prop } from 'vue-property-decorator'
import BuilderDefaultContainer from '@/components/builder/BuilderDefaultContainer.vue'
import BuilderDevice from '@/components/builder/BuilderDevice.vue'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import WithBuilderFakeChats from '@/mixins/WithBuilderFakeChats'
import { ChatStubState } from './BuilderChat.vue'
import BuilderDot from "@/components/builder/BuilderDot.vue"

@Component({
  components: {
    BuilderButton,
    BuilderTooltip,
    BuilderDevice,
    BuilderDefaultContainer,
    BuilderDot
  },
})
export default class BuilderChatCreateChannels extends Mixins(WithBuilderFakeChats) {
  @Prop({ required: true, type: Object }) readonly value!: ChatStubState

  @Prop({ required: true, type: Number }) readonly step!: number

  processing = false

  async onNextClick(): Promise<void> {
    this.processing = true

    try {
      this.$emit('next')
    } catch (e) {
      this.$toasted.error(e.message)
    }

    this.processing = false
  }

  async onStubStateReady(): Promise<void> {
    if (this.value.channels.length < 3) {
      this.$emit('back')
      return
    }

    this.$emit('input', {
      ...this.value,
      create: true,
      title: 'Create',
      headerIcon: 'bg-delete-chats-icon',
    })
  }
}
